import {
  REQUEST_LOGISTIC_TRIPS,
  RESPONSE_LOGISTIC_TRIPS,
  REQUEST_LOGISTIC_TRIPS_FAILURE,
  REQUEST_LOGISTIC_TRIP,
  RESPONSE_LOGISTIC_TRIP,
  REQUEST_LOGISTIC_TRIP_FAILURE,
  REQUEST_CREATE_LOGISTIC_TRIP,
  RESPONSE_CREATE_LOGISTIC_TRIP,
  REQUEST_CREATE_LOGISTIC_TRIP_FAILURE,
  REQUEST_DELETE_LOGISTIC_TRIP,
  RESPONSE_DELETE_LOGISTIC_TRIP,
  REQUEST_DELETE_LOGISTIC_TRIP_FAILURE,
  REQUEST_UPDATE_LOGISTIC_TRIP,
  RESPONSE_UPDATE_LOGISTIC_TRIP,
  REQUEST_UPDATE_LOGISTIC_TRIP_FAILURE,
  ON_SELECT_LOGISTIC_TRIP,
  REQUEST_COPY_LOGISTIC_TRIP,
  RESPONSE_COPY_LOGISTIC_TRIP,
  REQUEST_COPY_LOGISTIC_TRIP_FAILURE,
  REQUEST_ADD_UNIT_LOGISTIC_TRIP,
  RESPONSE_ADD_UNIT_LOGISTIC_TRIP,
  REQUEST_ADD_UNIT_LOGISTIC_TRIP_FAILURE,
  REQUEST_DELETE_UNIT_LOGISTIC_TRIP,
  RESPONSE_DELETE_UNIT_LOGISTIC_TRIP,
  REQUEST_DELETE_UNIT_LOGISTIC_TRIP_FAILURE,
  REQUEST_LOGISTIC_TRIPS_GEO,
  RESPONSE_LOGISTIC_TRIPS_GEO,
  REQUEST_LOGISTIC_TRIPS_GEO_FAILURE,
  REQUEST_UPDATE_LOGISTIC_TRIPS_ALARM,
  RESPONSE_UPDATE_LOGISTIC_TRIPS_GEO_ALATM,
  REQUEST_UPDATE_LOGISTIC_TRIPS_GEO_ALARM_FAILURE,
} from "../actions/logisticTripsActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  logisticTripsDataState: queriesStates.NOT_REQUESTED,
  logisticTripDataState: queriesStates.NOT_REQUESTED,
  logisticTripGeoJsonDataState: queriesStates.NOT_REQUESTED,
  logisticCreateTripsDataState: queriesStates.NOT_REQUESTED,
  logisticDeleteTripsDataState: queriesStates.NOT_REQUESTED,
  logisticUpdateTripsDataState: queriesStates.NOT_REQUESTED,
  logisticCopyTripDataState: queriesStates.NOT_REQUESTED,
  logisticAddUnitTripDataState: queriesStates.NOT_REQUESTED,
  logisticDeleteUnitTripDataState: queriesStates.NOT_REQUESTED,
  logisticTripGeojsonDataState: queriesStates.NOT_REQUESTED,
  logisticUpdateTripAlarmDataState: queriesStates.NOT_REQUESTED,
  logisticSelectedTrip: null,
  logisticTrips: [],
  errors: [],
};

const logisticTripsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_LOGISTIC_TRIPS: {
      return Object.assign({}, state, {
        logisticTripsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_TRIPS: {
      return Object.assign({}, state, {
        logisticTripsDataState: queriesStates.READY,
        logisticTrips: action.data.trips,
      });
    }
    case REQUEST_LOGISTIC_TRIPS_FAILURE: {
      return Object.assign({}, state, {
        logisticTripsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticTripDataState: queriesStates.READY,
        logisticSelectedTrip: action.data,
      });
    }
    case REQUEST_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticCreateTripsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_LOGISTIC_TRIP: {
      const logisticSelectedTrip = action.data;
      logisticSelectedTrip.routes = [];
      logisticSelectedTrip.unit = null;

      return Object.assign({}, state, {
        logisticCreateTripsDataState: queriesStates.READY,
        logisticTrips: state.logisticTrips.concat(action.data),
        logisticSelectedTrip: logisticSelectedTrip,
      });
    }
    case REQUEST_CREATE_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticCreateTripsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticDeleteTripsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticDeleteTripsDataState: queriesStates.READY,
        logisticTrips: state.logisticTrips.filter((x) => {
          return x.id !== action.data.id;
        }),
        logisticSelectedTrip: null,
      });
    }
    case REQUEST_DELETE_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticDeleteTripsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case ON_SELECT_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticSelectedTrip: action.data,
      });
    }

    case REQUEST_UPDATE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticUpdateTripsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_UPDATE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticUpdateTripsDataState: queriesStates.READY,
        logisticSelectedTrip: action.data,
      });
    }
    case REQUEST_UPDATE_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticUpdateTripsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_COPY_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticCopyTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_COPY_LOGISTIC_TRIP: {
      const logisticTrips = state.logisticTrips;

      logisticTrips.splice(action.index, 0, action.data);

      return Object.assign({}, state, {
        logisticCopyTripDataState: queriesStates.READY,
        logisticTrips: logisticTrips,
      });
    }
    case REQUEST_COPY_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticCopyTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_ADD_UNIT_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticAddUnitTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_ADD_UNIT_LOGISTIC_TRIP: {
      const logisticSelectedTrip = state.logisticSelectedTrip;
      logisticSelectedTrip.unit = action.data;

      return Object.assign({}, state, {
        logisticAddUnitTripDataState: queriesStates.READY,
        logisticSelectedTrip: logisticSelectedTrip,
      });
    }
    case REQUEST_ADD_UNIT_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticAddUnitTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_UNIT_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticDeleteUnitTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_UNIT_LOGISTIC_TRIP: {
      const logisticSelectedTrip = state.logisticSelectedTrip;
      logisticSelectedTrip.unit = null;
      logisticSelectedTrip.alarm.active = false;

      return Object.assign({}, state, {
        logisticDeleteUnitTripDataState: queriesStates.READY,
        logisticSelectedTrip: logisticSelectedTrip,
      });
    }
    case REQUEST_DELETE_UNIT_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticDeleteUnitTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_LOGISTIC_TRIPS_GEO: {
      return Object.assign({}, state, {
        logisticTripGeojsonDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_TRIPS_GEO: {
      const logisticSelectedTrip = state.logisticSelectedTrip;
      if (logisticSelectedTrip !== null) {
        logisticSelectedTrip.geojsonData = action.data;
      }

      return Object.assign({}, state, {
        logisticTripGeojsonDataState: queriesStates.READY,
        logisticSelectedTrip: logisticSelectedTrip,
      });
    }
    case REQUEST_LOGISTIC_TRIPS_GEO_FAILURE: {
      return Object.assign({}, state, {
        logisticTripGeojsonDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_UPDATE_LOGISTIC_TRIPS_ALARM: {
      return Object.assign({}, state, {
        logisticUpdateTripAlarmDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_UPDATE_LOGISTIC_TRIPS_GEO_ALATM: {
      const logisticSelectedTrip = state.logisticSelectedTrip;
      logisticSelectedTrip.alarm = action.data;

      return Object.assign({}, state, {
        logisticUpdateTripAlarmDataState: queriesStates.READY,
        logisticSelectedTrip: logisticSelectedTrip,
        logisticTrips: state.logisticTrips.map((x) => {
          if (x.id === logisticSelectedTrip.id) {
            x.alarm = action.data;
          }

          return x;
        }),
      });
    }
    case REQUEST_UPDATE_LOGISTIC_TRIPS_GEO_ALARM_FAILURE: {
      return Object.assign({}, state, {
        logisticUpdateTripAlarmDataState: queriesStates.FAILURE,
        errors: state.errors.concat(action.errors),
      });
    }

    default:
      return state;
  }
};

export default logisticTripsReducer;
